// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import moment from 'moment';
import VueMoment from 'vue-moment';
import VueTruncate from 'vue-truncate-filter';
import VueSmoothScroll from 'vue2-smooth-scroll';
import VueSanitizeHtml from 'vue-sanitize-html-plugin';
import VModal from 'vue-js-modal';

import App from './App';
import router from './router';
import axios from 'axios';


// Import translations
import en from './lang/en';
import nl from './lang/nl';

// Import components
import TalkingBird from './components/TalkingBird';
import Task from './components/Task';
import Deal from './components/Deal';
import Appointment from './components/Appointment';
import Ticket from './components/Ticket';
import Pagination from './components/Pagination';
import DataTable from './components/DataTable';
import DataTableVue from './components/DataTableVue';
import TopData from './components/TopData';
import Message from './components/Message';
import ErrorMessage from './components/ErrorMessage';

// Initialize filters
import relativeTime from './filters/relativeTime';

// Initialize components
if(process.env.NODE_ENV === 'production') axios.defaults.baseURL = 'http://localhost:3000';

Vue.component('talking-bird', TalkingBird);
Vue.component('task', Task);
Vue.component('deal', Deal);
Vue.component('appointment', Appointment);
Vue.component('ticket', Ticket);
Vue.component('pagination', Pagination);
Vue.component('datatable', DataTable);
Vue.component('datatablevue', DataTableVue);
Vue.component('topdata', TopData);
Vue.component('message', Message);
Vue.component('error-message', ErrorMessage);

// Initialize plug-ins
Vue.use(VueTruncate);
Vue.use(VueSmoothScroll);
Vue.use(VModal);

Vue.use(VueMoment, {
  moment,
});

Vue.use(VueSanitizeHtml, {
  allowedTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
    'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div', 'sup',
    'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'font', 'img'],
  allowedAttributes: {
    a: ['href'],
    font: ['color'],
    span: ['style'],
    img: ['src', 'width', 'height', 'style'],
    p: ['style'],
    div: ['style'],
  },
});

Vue.filter('relativeTime', relativeTime);

// Initialize internationalisation
const locale = 'nl';
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'nl',
  messages: {
    en, nl,
  },
});

Vue.moment.locale(locale);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js